// @flow
import { useMatch } from 'react-router-dom';
import { PATH } from 'config/constants';

export const useViewerId = (): ?string => {
  const match = useMatch(PATH.VIEWER);

  return match?.params.windowId;
};
